<template>
    <ItemCard :title="checklist.title">
        <template v-slot:badges>
            <div class="badge state-good">{{ $t("Template") }}</div>
        </template>
    </ItemCard>
</template>

<script>
import ItemCard from '@mobile/components/ItemCard.vue';
import { now } from '@/util/UnixTimestamps';

export default {
    components: { ItemCard },

    props: {
        checklist: {
            type: Object,
            required: true,
        },
    },

    computed: {
        hoursSinceLastRetrieved() {
            return Math.round((now() - this.checklist.retrieved_at) / 60 / 60);
        },
    },

    methods: {

    },

};
</script>
